import {APIDefinitionSpec, APIDataSpec, defineEndpoint} from '../API';
import {App, User} from '../../types/commons';
import {CreateApplicationPayload, UpdateApplicationPayload} from '../../admin/store/partials/Applications';
import {UserForm, UpdateUserPayload} from '../../admin/store/partials/Users';
import {ManifestImages} from '../../types/manifest';
import {EnterpriseState} from '../../admin/store/partials/Enterprise';
import {SearchEngine, SearchEnginePayload} from '../../admin/store/partials/SearchEngines';

export const enum AdminAPI {
    APPS = 'ADMIN_APPS',
    MANIFEST = 'ADMIN_MANIFEST',
    MANIFEST_OVERRIDE = 'ADMIN_MANIFEST_OVERRIDE',
    SETTINGS = 'ADMIN_SETTINGS',
    USERS = 'ADMIN_USERS',
    SEARCH_ENGINES = 'ADMIN_SEARCH_ENGINES'
}

export const AdminData: APIDataSpec<typeof AdminAPI> = {
    APPS: defineEndpoint(AdminAPI.APPS, 'api/admin/apps/${id}', {
        defaultParams: {id: ''}
    }),
    MANIFEST: defineEndpoint(AdminAPI.MANIFEST, 'api/launcher.json'),
    MANIFEST_OVERRIDE: defineEndpoint(AdminAPI.MANIFEST_OVERRIDE, 'api/admin/manifest'),
    SETTINGS: defineEndpoint(AdminAPI.SETTINGS, 'api/admin/settings'),
    USERS: defineEndpoint(AdminAPI.USERS, 'api/admin/users/${id}', {
        defaultParams: {id: ''}
    }),
    SEARCH_ENGINES: defineEndpoint(AdminAPI.SEARCH_ENGINES, 'api/admin/search-engines/${id}', {
        defaultParams: {id: ''}
    })
};
export interface AdminTypes extends APIDefinitionSpec<AdminAPI> {
    [AdminAPI.APPS]: {
        GET: [App[], {scope: 'user' | 'all'}];
        POST: [{status: string; app: App}, void, {application: CreateApplicationPayload}];
        PUT: [{status: string; app: App}, {id: string}, {application: UpdateApplicationPayload}];
        DELETE: [{status: string}, {id: string}, void];
    };
    [AdminAPI.MANIFEST]: {
        GET: [void, void];
    };
    [AdminAPI.MANIFEST_OVERRIDE]: {
        GET: [ManifestImages | null, void];
        POST: [{status: string}, void, {manifest: ManifestImages}];
    };
    [AdminAPI.SETTINGS]: {
        GET: [EnterpriseState | null, void];
        POST: [{status: string}, void, {settings: EnterpriseState}];
    };
    [AdminAPI.SEARCH_ENGINES]: {
        GET: [SearchEngine[], void];
        POST: [{status: string}, void, {engine: SearchEnginePayload}];
        PUT: [{status: string; engine: SearchEngine}, {id: string}, {engine: SearchEnginePayload}];
        DELETE: [{status: string}, {id: string}, void];
    };
    [AdminAPI.USERS]: {
        GET: [User[], void];
        POST: [{
            status: string; user: User;
        }, void, UserForm];
        PUT: [{status: string; user: User}, {id: string}, Partial<UpdateUserPayload>];
        DELETE: [{status: string}, {id: string}, void];
    };
}
